import { ROUTES } from '@constants';
import { useAppSelector } from '@store';

export const useLoadedApp = () => {
    const isAdmin = useAppSelector((state) => state.domain.settings.is_admin_panel);
    const isWidget = window.location.pathname.startsWith('/widget');
    const isPolicy = window.location.pathname.startsWith('/policy');
    const isApiDocs = window.location.pathname.startsWith(ROUTES.API.DOCS);

    return {
        isAdmin,
        isWidget,
        isApiDocs,
        isPolicy,
    };
};
